export enum ShimmerTypes {
  LINE = 'line',
  SQUARE = 'square',
  CIRCLE = 'circle',
}

export interface ShimmerOptions {
  width: string;
  height: string;
  borderRadius: string;
  colors: {
    background: string;
    1: string;
    2: string;
    3: string;
    4: string;
  };
  duration: string;
}
